import { take, call, put } from "redux-saga/effects";
import Auth from "@defi/core-auth";
import { PATH_ROOT } from "../paths";
import { REQUEST_FORGOT_PW_CHANGE, SET_MFA_CHALLENGE } from "../actions/constants";
import { SENDING_REQUEST, REQUEST_ERROR } from "@defi/core-auth";
import forwardTo from "./forwardTo";

export function* forgotPasswordConfirm({ username, password, mfaCode }) {
	// We send an action that tells Redux we're sending a request
	yield put({ type: SENDING_REQUEST, sending: true });

	// We then try to log in the user
	try {
		let response = yield call(Auth.forgotPasswordConfirm, username, password, mfaCode);

		if (response.Success) {
			yield put({ type: SET_MFA_CHALLENGE, challenge: false });
			yield call(forwardTo, PATH_ROOT);
			return response;
		} else {
			//console.log(response.Errors[0]);
			yield put({ type: REQUEST_ERROR, error: [ response.Errors[0] ] });
			return false;
		}
	} catch (error) {
		yield put({ type: REQUEST_ERROR, error: [ error.message ] });
		return false;
	} finally {
		// When done, we tell Redux we're not in the middle of a request any more
		yield put({ type: SENDING_REQUEST, sending: false });
	}
}

export function* forgotPasswordConfirmFlow() {
	while (true) {
		let request = yield take(REQUEST_FORGOT_PW_CHANGE);
		let { username, password, mfaCode } = request.data;
		yield call(forgotPasswordConfirm, {
			username,
			password,
			mfaCode,
		});
	}
}
